export default __webpack_public_path__ + "static/media/box2_step5.798eb160.png";